import { render, staticRenderFns } from "./VoucherDashboard.vue?vue&type=template&id=53fc2390&"
import script from "./VoucherDashboard.vue?vue&type=script&lang=js&"
export * from "./VoucherDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports